import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-data",
  "use": "icon-data-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-data\"><defs><style type=\"text/css\"></style></defs><path d=\"M170.666667 853.333333h768v85.333334H85.333333V85.333333h85.333334v768z m128-384h85.333333v298.666667h-85.333333V469.333333z m234.666666-256h85.333334v554.666667h-85.333334V213.333333z m234.666667 128h85.333333v426.666667h-85.333333V341.333333z\" p-id=\"13035\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol